import { useCreateManualFormModal } from '~/components/Modals/ManualFormModal';
import { useAppNavigation } from '~/hooks/nav.hook';
import { translate } from '~/utils/translation.utils';

export const useVoucherByEmailModal = () => {
  const navigation = useAppNavigation();

  return useCreateManualFormModal({
    title: translate('voucher.voucherEmail'),
    subtitle: translate('voucher.enterEmail'),
    formData: [
      {
        items: [
          {
            type: 'email',
            label: translate('voucher.email'),
            id: 'voucherEmail',
          },
        ],
      },
    ],
    onConfirm: (value) => {
      navigation.navigate('VouchersByEmail', value);
    },
  });
};
